import TypographySecondary from 'components/Typography/Secondary'
import styled from 'styled-components'

const HistoryPlaceholder = ({ item }: { item: string }) => {
    return (
        <StyledMessageWrapper>
            <TypographySecondary value={`No recent ${item}s `} size='small' semiBold />
            <TypographySecondary value={`Your ${item} history will appear here`} size='xs-small' />
        </StyledMessageWrapper>
    )
}

export default HistoryPlaceholder

const StyledMessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;

    height: 80%;
`
